<template>
    <img
        :src="src"
        :alt="`An icon representing '${computedTitle}'`"
        :style="style"
        v-bind="$attrs"
        @error="e => (e.target.src = '/img/thankbox-icons/icons8-star-100.svg')"
    />
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
    title?: string
    icon?: string
    size?: number
}>()

const src = computed(() => {
    const thankboxIcon = props?.icon

    const icon = thankboxIcon || titleIcon.value
    return `/img/thankbox-icons/${icon}`
})

const computedTitle = computed(() => {
    return props.title || ''
})

const style = computed(() => {
    return props.size !== undefined
        ? {
              width: `${props.size}px`,
              height: `${props.size}px`,
          }
        : {}
})

/**
 * If no explicit icon has been set, pick best one based on the title
 * Make sure to keep this method in line with the one in Thankbox.php
 */
const titleIcon = computed(() => {
    const title = computedTitle.value.toLowerCase().replace(/!/g, '') || ''

    // If create preview sample title, show star icon
    if (title === 'thankbox title') {
        return 'icons8-star-100.svg'
    }

    if (title.includes('get well') || title.includes('feel better')) {
        return 'icons8-doctors-bag-100.svg'
    } else if (title.includes('birthday')) {
        return 'icons8-birthday-50.svg'
    } else if (title.includes('thank')) {
        return 'icons8-trust-100.svg'
    } else if (
        title.includes('miss you') ||
        title.includes('goodbye') ||
        title.includes('leaving') ||
        title.includes('farewell')
    ) {
        return 'icons8-so-so-50.svg'
    } else if (title.includes('good luck')) {
        return 'icons8-clover-100.svg'
    } else if (title.includes('congrat')) {
        return 'icons8-confetti-100.svg'
    } else if (title.includes("season's greetings") || title.includes('christmas')) {
        return 'icons8-jingle-bell-100.svg'
    } else if (title.includes('retirement')) {
        return 'icons8-beach-50.svg'
    } else if (title.includes('maternity') || title.includes('baby')) {
        return 'icons8-pacifier-100.svg'
    } else if (title.includes('work anniversary')) {
        return 'icons8-champagne-bottle-100.svg'
    } else if (title.includes('happy anniversary')) {
        return 'icons8-romance-100.svg'
    }

    return 'icons8-star-100.svg'
})
</script>
